import SearchQuery from '../general/SearchQuery';
import SuggestionsCheckbox from './SuggestionsCheckbox';

export default function GameCard({ text, suggestions }) {
  return (
    <div className="mt-4 bg-white dark:bg-background-dark dark:text-text-dark text-sm rounded-2xl sm:w-full">
      {/*top part*/}
      <div>
        <div className="py-1 flex items-center justify-between rounded-t-2xl border border-gray">
          <SearchQuery text={`${text}...`} />
        </div>
      </div>
      {/*bottom part*/}
      <div className="py-3 rounded-b-2xl border-r border-l border-b border-gray">
        <SuggestionsCheckbox prompt={text} suggestions={suggestions} />
      </div>
    </div>
  );
}
